import { render, staticRenderFns } from "./role_edit.vue?vue&type=template&id=20f88365&scoped=true"
import script from "./role_edit.vue?vue&type=script&lang=ts"
export * from "./role_edit.vue?vue&type=script&lang=ts"
import style0 from "./role_edit.vue?vue&type=style&index=0&id=20f88365&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f88365",
  null
  
)

export default component.exports